<template>
  <div>
    <Header />

    <div class="container-fluid users-container">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <DivvyAdminSidebar />
        </div>

        <transition appear name="fade">
          <div class="col-md-9 right-container">
            <div class="col-md-12 pt-4">
              <!--  -->

              <p>
                User <strong>{{ Name }}</strong> {{ action }}
              </p>

              <!-- <div class="mb-2">
                <label for="style"> Style : </label>
                <select class="ml-2" name="style" id="">
                  <option value="classic">
                    Classic
                  </option>
                  <option value="unit">
                    Unit
                  </option>
                </select>
              </div> -->

              <div>
                <router-link class="btn btn-primary mr-3" :to="{ name: 'DivvyAdminUsersAddUser' }" @click.native="scrollToTop">
                  Add User
                </router-link>
                <router-link class="btn btn-primary" :to="{ name: 'Users' }" @click.native="scrollToTop">
                  User Manager
                </router-link>
              </div>
              <!--  -->
            </div>
          </div>
        </transition>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import DivvyAdminSidebar from '@/views/divvyadmin/divvyAdminSidebar.vue';

export default {
  name: 'UsersAddUpdScreen',
  props: ['Name', 'action'],
  data() {
    return {};
  },
  components: {
    DivvyAdminSidebar,
    Header,
    Footer,
  },

  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch('divvyAdminSidebar/setActive', {
        activeMenuItem: this.activeMenuItem ? this.activeMenuItem : 'usersmodule',
        activeMenu: this.activeMenu ? this.activeMenu : 'clientusermanagement',
      });
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },

  created() {
    this.scrollToTop();
    this.setActiveMenuItem();
    this.$store.dispatch("manageUsers/fetchGetUsers");
  },
};
</script>

<style lang="scss" scoped>
.users-container {
  min-height: 100%;
  margin: -14px 0 0 0;
}
</style>
